var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PathwaysAPIError, PathwaysError } from './utils';
var defaultOptions = {
    baseUrl: 'https://pathways.example.com/v1/apps/{{app_ubiquity_token}}/',
    fetch: undefined,
};
var pathMap = {
    createAppUser: 'appusers/',
    createAppUserJourney: 'appusers/{{appUserId}}/journeys/',
    createAppUserJourneyIndexEvent: 'appusers/{{appUserId}}/journeys/{{journeyId}}/index-events/',
    createAppUserPathway: 'appusers/{{appUserId}}/pathways/',
    createIndexEventType: 'index-event-types/',
    createPathway: 'pathways/',
    createPathwayIndexEvent: 'pathways/{{pathwayId}}/index-events/',
    createPathwayStage: 'pathways/{{pathwayId}}/stages/',
    createRule: 'rules/',
    deleteAppUserJourneyIndexEvent: 'appusers/{{appUserId}}/journeys/{{journeyId}}/index-events/{{indexEventId}}/',
    deleteIndexEventType: 'index-event-types/{{indexEventId}}/',
    deletePathway: 'pathways/{{pathwayId}}/',
    deletePathwayIndexEvent: 'pathways/{{pathwayId}}/index-events/{{indexEventId}}/',
    deletePathwayStage: 'pathways/{{pathwayId}}/stages/{{stageId}}/',
    deleteRule: 'rules/{{ruleId}}/',
    duplicatePathway: 'pathways/{{pathwayId}}/duplicate/',
    getPathway: 'pathways/{{pathwayId}}',
    getRule: 'rules/{{ruleId}}',
    listAppUsers: 'appusers/',
    listIndexEventTypes: 'index-event-types/',
    listPathways: 'pathways/',
    listPathwayIndexEvents: 'pathways/{{pathwayId}}/index-events/',
    listPathwayStages: 'pathways/{{pathwayId}}/stages/',
    listRules: 'rules/',
    patchAppUserPathway: 'appusers/{{appUserId}}/pathways/{{appUserPathwayId}}/',
    patchAppUserJourneyIndexEvent: 'appusers/{{appUserId}}/journeys/{{journeyId}}/index-events/{{indexEventId}}/',
    patchIndexEventType: 'index-event-types/{{indexEventId}}/',
    patchPathway: 'pathways/{{pathwayId}}/',
    patchPathwayIndexEvent: 'pathways/{{pathwayId}}/index-events/{{indexEventId}}/',
    patchPathwayStage: 'pathways/{{pathwayId}}/stages/{{stageId}}/',
    patchRule: 'rules/{{ruleId}}/',
    processAppUserPathway: 'appusers/{{appUserId}}/pathways/{{appUserPathwayId}}/process/',
    transitionAppUserToPathwayStage: 'appusers/{{appUserId}}/pathways/{{appUserPathwayId}}/transition/',
    triggerAdhocRule: 'appusers/{{appUserId}}/pathways/{{appUserPathwayId}}/trigger_adhoc_rule/',
    createEngagementCheck: 'pathways/{{pathwayId}}/engagement-checks/',
    patchEngagementCheck: 'pathways/{{pathwayId}}/engagement-checks/{{checkId}}/',
    deleteEngagementCheck: 'pathways/{{pathwayId}}/engagement-checks/{{checkId}}/',
    listEngagementChecks: 'pathways/{{pathwayId}}/engagement-checks/',
    listPathwaySnapshots: 'pathways/{{pathwayId}}/snapshots/',
    createPathwaySnapshot: 'pathways/{{pathwayId}}/snapshots/',
    sharePathwaySnapshot: 'pathways/{{pathwayId}}/snapshots/{{snapshotId}}/share/',
    unsharePathwaySnapshot: 'pathways/{{pathwayId}}/snapshots/{{snapshotId}}/unshare/',
    listSharedPathwaySnapshots: 'shared-snapshots/',
    useSharedPathwaySnapshot: 'shared-snapshots/{{snapshotId}}/use/',
    actionJourneyEntry: 'appusers/{{appUserId}}/journeys/{{journeyId}}/entries/{{entryId}}/action/',
};
var PathwaysAdminClient = /** @class */ (function () {
    function PathwaysAdminClient(appToken, jwt, options) {
        var _this = this;
        var _a;
        this.appToken = appToken;
        this.jwt = jwt;
        this.apiRequest = function (pathKey, errorMessage, requestMethod, queryStringParameters, postData, pathParameters) { return __awaiter(_this, void 0, void 0, function () {
            var url, body, key, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrl(pathKey, queryStringParameters, pathParameters);
                        body = undefined;
                        if (postData) {
                            body = new FormData();
                            for (key in postData) {
                                body.append(key, postData[key]);
                            }
                        }
                        return [4 /*yield*/, this.fetch(url, {
                                method: requestMethod,
                                headers: {
                                    Authorization: "Bearer " + this.jwt,
                                },
                                body: body,
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw PathwaysAPIError(errorMessage, resp);
                        }
                        return [2 /*return*/, resp];
                }
            });
        }); };
        this.buildQueryStringParameters = function (params) {
            return Object.keys(params).reduce(function (acc, key) {
                var _a;
                return Object.assign({}, acc, params[key] !== undefined ? (_a = {}, _a[key] = params[key], _a) : {});
            }, {});
        };
        this.deleteRequest = function (pathKey, errorMessage, pathParameters) { return __awaiter(_this, void 0, void 0, function () {
            var url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrl(pathKey, undefined, pathParameters);
                        return [4 /*yield*/, this.fetch(url, {
                                method: 'DELETE',
                                headers: {
                                    Authorization: "Bearer " + this.jwt,
                                },
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw PathwaysAPIError(errorMessage, resp);
                        }
                        return [2 /*return*/, true];
                }
            });
        }); };
        this.getRequest = function (pathKey, errorMessage, queryStringParameters, pathParameters) {
            return _this.apiRequest(pathKey, errorMessage, 'GET', queryStringParameters, undefined, pathParameters);
        };
        this.patchRequest = function (pathKey, patchData, errorMessage, pathParameters, queryStringParameters) {
            return _this.apiRequest(pathKey, errorMessage, 'PATCH', queryStringParameters, patchData, pathParameters);
        };
        this.postRequest = function (pathKey, postData, errorMessage, queryStringParameters, pathParameters) {
            return _this.apiRequest(pathKey, errorMessage, 'POST', queryStringParameters, postData, pathParameters);
        };
        this.createAppUser = function (identityId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRequest('createAppUser', { identity_id: identityId }, 'Unable to create App User for Pathways service')];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.createAppUserJourney = function (appUserId, startDate) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRequest('createAppUserJourney', { start_date: startDate }, 'Unable to create App User Journey for Pathways service', undefined, { appUserId: appUserId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.createAppUserJourneyIndexEvent = function (appUserId, journeyId, eventTypeSlug, value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRequest('createAppUserJourneyIndexEvent', { event_type_slug: eventTypeSlug, value: value }, 'Unable to create App User Journey Index Event for Pathways service', undefined, { appUserId: appUserId, journeyId: "" + journeyId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.createAppUserPathway = function (appUserId, appUserPathwayData) { return __awaiter(_this, void 0, void 0, function () {
            var ruleIds, postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ruleIds = typeof appUserPathwayData.disabledRuleIds === 'string'
                            ? appUserPathwayData.disabledRuleIds
                            : JSON.stringify(appUserPathwayData.disabledRuleIds);
                        postData = {
                            journey_id: appUserPathwayData.journeyId,
                            original_pathway_id: appUserPathwayData.originalPathway,
                            current_stage_slug: appUserPathwayData.currentStageSlug,
                            disabled_rule_ids: ruleIds,
                            owner_id: appUserPathwayData.ownerId,
                            external_id: appUserPathwayData.externalId,
                        };
                        return [4 /*yield*/, this.postRequest('createAppUserPathway', postData, 'Unable to create App User Pathway for Pathways service', undefined, { appUserId: appUserId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.createIndexEventType = function (name, slug, translatedNames) { return __awaiter(_this, void 0, void 0, function () {
            var postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = {
                            name: name,
                            slug: slug,
                            translated_names: JSON.stringify(translatedNames),
                        };
                        return [4 /*yield*/, this.postRequest('createIndexEventType', postData, 'Unable to create Index Event Type')];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.createPathway = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = {
                            name: data.name,
                            description: data.description,
                            is_active: data.isActive,
                            metadata: JSON.stringify(data.metadata || {}),
                            owner_id: data.ownerId,
                            external_id: data.externalId || undefined,
                            is_managed_pathway: data.isManagedPathway,
                        };
                        return [4 /*yield*/, this.postRequest('createPathway', postData, 'Unable to create Pathway')];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.createPathwayIndexEvent = function (pathwayId, eventTypeSlug, rules) { return __awaiter(_this, void 0, void 0, function () {
            var postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = __assign({ event_type_slug: eventTypeSlug }, (rules ? { rules: JSON.stringify(rules) } : {}));
                        return [4 /*yield*/, this.postRequest('createPathwayIndexEvent', postData, 'Unable to create Pathway Index Event', undefined, { pathwayId: "" + pathwayId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.createPathwayStage = function (pathwayId, stageData) { return __awaiter(_this, void 0, void 0, function () {
            var postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = {
                            number: stageData.number,
                            name: stageData.name,
                            slug: stageData.slug,
                            description: stageData.description,
                            is_adhoc: stageData.isAdhoc,
                            rules: JSON.stringify(stageData.rules),
                        };
                        return [4 /*yield*/, this.postRequest('createPathwayStage', postData, 'Unable to create Pathway Stage', undefined, { pathwayId: "" + pathwayId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.createRule = function (ruleData) { return __awaiter(_this, void 0, void 0, function () {
            var postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = __assign(__assign(__assign(__assign({}, ruleData), { who_detail: JSON.stringify(ruleData.whoDetail), when_detail: JSON.stringify(ruleData.whenDetail), what_detail: JSON.stringify(ruleData.whatDetail) }), (ruleData.metadata ? { metadata: JSON.stringify(ruleData.metadata) } : {})), { owner_id: ruleData.ownerId, audience_type: ruleData.audienceType });
                        return [4 /*yield*/, this.postRequest('createRule', postData, 'Unable to create Rule')];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.deleteAppUserJourneyIndexEvent = function (appUserId, journeyId, indexEventId) {
            return _this.deleteRequest('deleteAppUserJourneyIndexEvent', 'Unable to delete App User Journey Index Event', { appUserId: appUserId, journeyId: journeyId, indexEventId: indexEventId });
        };
        this.deleteIndexEventType = function (indexEventId) {
            return _this.deleteRequest('deleteIndexEventType', 'Unable to delete Index Event Type', {
                indexEventId: "" + indexEventId,
            });
        };
        this.deleteRule = function (ruleId) {
            return _this.deleteRequest('deleteRule', 'Unable to delete Rule from Pathways service', {
                ruleId: "" + ruleId,
            });
        };
        this.deletePathwayIndexEvent = function (pathwayId, indexEventId) {
            return _this.deleteRequest('deletePathwayIndexEvent', 'Unable to delete Pathway Index Event', {
                pathwayId: "" + pathwayId,
                indexEventId: "" + indexEventId,
            });
        };
        this.deletePathwayStage = function (pathwayId, stageId) {
            return _this.deleteRequest('deletePathwayStage', 'Unable to delete Pathway Stage', {
                pathwayId: "" + pathwayId,
                stageId: "" + stageId,
            });
        };
        this.duplicatePathway = function (pathwayId, updatedMetadata, ownerId) { return __awaiter(_this, void 0, void 0, function () {
            var postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = __assign(__assign({}, (updatedMetadata ? { updated_metadata: JSON.stringify(updatedMetadata) } : {})), { updated_owner_id: ownerId || undefined });
                        return [4 /*yield*/, this.postRequest('duplicatePathway', postData, 'Unable to duplicate Pathway', undefined, { pathwayId: "" + pathwayId })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getPathway = function (pathwayId, withRules) {
            if (withRules === void 0) { withRules = true; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getRequest('getPathway', "Unable to get data for Pathway ID " + pathwayId, { with_rules: withRules }, { pathwayId: "" + pathwayId })];
                        case 1: return [2 /*return*/, (_a.sent()).json()];
                    }
                });
            });
        };
        this.getRule = function (ruleId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequest('getRule', "Unable to get data for Rule ID " + ruleId, undefined, {
                            ruleId: "" + ruleId,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.listAppUsers = function (page, identityId) { return __awaiter(_this, void 0, void 0, function () {
            var queryStringParameters;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryStringParameters = {};
                        if (page) {
                            queryStringParameters = { page: page };
                        }
                        if (identityId) {
                            queryStringParameters = { identity_id: identityId };
                        }
                        return [4 /*yield*/, this.getRequest('listAppUsers', 'Unable to get list of App Users from Pathways service', this.buildQueryStringParameters(queryStringParameters))];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.listEntriesForJourney = function (journey) { return __awaiter(_this, void 0, void 0, function () {
            var results, next, resp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        results = [];
                        next = journey.entries;
                        _a.label = 1;
                    case 1:
                        if (!next) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.fetch(next, {
                                method: 'GET',
                                headers: {
                                    Authorization: "Bearer " + this.jwt,
                                },
                            })];
                    case 2:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw 'Unable to list entries for journey';
                        }
                        return [4 /*yield*/, resp.json()];
                    case 3:
                        data = _a.sent();
                        next = data.next;
                        results = results.concat(data.results);
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, results];
                }
            });
        }); };
        this.listIndexEventsForJourney = function (journey) { return __awaiter(_this, void 0, void 0, function () {
            var resp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(journey.index_events, {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer " + this.jwt,
                            },
                        })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw 'Unable to list index events for journey';
                        }
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data.results];
                }
            });
        }); };
        this.listIndexEventTypes = function (page) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequest('listIndexEventTypes', 'Unable to get list of Index Events from Pathways service', this.buildQueryStringParameters({ page: page }))];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.listPathways = function (page, withRules, isDeleted, ownerId) {
            if (withRules === void 0) { withRules = true; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getRequest('listPathways', 'Unable to get list of Pathways from Pathways service', this.buildQueryStringParameters({
                                page: page,
                                is_deleted: isDeleted,
                                with_rules: withRules,
                                owner_id: ownerId,
                            }))];
                        case 1: return [2 /*return*/, (_a.sent()).json()];
                    }
                });
            });
        };
        this.listPathwayIndexEvents = function (pathwayId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequest('listPathwayIndexEvents', 'Unable to get list of Pathway Index Events', undefined, { pathwayId: "" + pathwayId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.listPathwayStages = function (pathwayId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequest('listPathways', 'Unable to get list of Pathways from Pathways service', undefined, { pathwayId: "" + pathwayId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.listRules = function (page, ownerId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequest('listRules', 'Unable to get list of Rules from Pathways service', this.buildQueryStringParameters({ page: page, owner_id: ownerId }))];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.patchAppUserPathway = function (appUserId, appUserPathwayId, currentStageSlug, disabledRuleIds, isActive, ownerId, externalId) { return __awaiter(_this, void 0, void 0, function () {
            var patchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        patchData = __assign(__assign(__assign(__assign(__assign({}, (currentStageSlug ? { current_stage_slug: currentStageSlug } : {})), (disabledRuleIds ? { disabled_rule_ids: disabledRuleIds } : {})), (isActive === undefined ? {} : { is_active: isActive })), (ownerId ? { owner_id: ownerId } : {})), { external_id: externalId || '' });
                        return [4 /*yield*/, this.patchRequest('patchAppUserPathway', patchData, 'Unable to update App User Pathway for Pathways service', { appUserId: "" + appUserId, appUserPathwayId: "" + appUserPathwayId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.patchAppUserJourneyIndexEvent = function (appUserId, journeyId, indexEventId, indexEventDate) { return __awaiter(_this, void 0, void 0, function () {
            var patchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        patchData = { value: indexEventDate };
                        return [4 /*yield*/, this.patchRequest('patchAppUserJourneyIndexEvent', patchData, 'Unable to update App User Journey Index Event for Pathways service', { appUserId: appUserId, journeyId: "" + journeyId, indexEventId: "" + indexEventId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.processAppUserPathway = function (appUserId, appUserPathwayId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRequest('processAppUserPathway', {}, 'Unable to process App User Pathway for Pathways service', undefined, { appUserId: "" + appUserId, appUserPathwayId: "" + appUserPathwayId })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.patchIndexEventType = function (indexEventId, name, slug, translatedNames, order) { return __awaiter(_this, void 0, void 0, function () {
            var patchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        patchData = __assign(__assign(__assign(__assign({}, (name ? { name: name } : {})), (slug ? { slug: slug } : {})), (translatedNames ? { translated_names: JSON.stringify(translatedNames) } : {})), (order ? { order_index: order } : {}));
                        return [4 /*yield*/, this.patchRequest('patchIndexEventType', patchData, 'Unable to update Index Event Type', { indexEventId: "" + indexEventId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.patchPathway = function (pathwayId, pathwayData) { return __awaiter(_this, void 0, void 0, function () {
            var patchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        patchData = __assign({ name: pathwayData.name, description: pathwayData.description, is_active: pathwayData.isActive, is_deleted: pathwayData.isDeleted }, (pathwayData.metadata ? { metadata: JSON.stringify(pathwayData.metadata) } : {}));
                        if (pathwayData.isManagedPathway) {
                            patchData.is_managed_pathway = pathwayData.isManagedPathway;
                        }
                        return [4 /*yield*/, this.patchRequest('patchPathway', patchData, 'Unable to update Pathway', {
                                pathwayId: "" + pathwayId,
                            })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.patchPathwayIndexEvent = function (pathwayId, indexEventId, eventTypeSlug, rules) { return __awaiter(_this, void 0, void 0, function () {
            var patchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        patchData = __assign(__assign({}, (eventTypeSlug ? { event_type_slug: eventTypeSlug } : {})), (rules ? { rules: JSON.stringify(rules) } : {}));
                        return [4 /*yield*/, this.patchRequest('patchPathwayIndexEvent', patchData, 'Unable to update Pathway Index Event', { pathwayId: "" + pathwayId, indexEventId: "" + indexEventId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.patchPathwayStage = function (pathwayId, stageId, stageData) { return __awaiter(_this, void 0, void 0, function () {
            var patchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        patchData = __assign({ number: stageData.number, name: stageData.name, slug: stageData.slug, description: stageData.description, is_adhoc: stageData.isAdhoc, rules: JSON.stringify(stageData.rules) }, (stageData.isDeleted ? { is_deleted: true } : {}));
                        return [4 /*yield*/, this.patchRequest('patchPathwayStage', patchData, 'Unable to update Pathway Stage', {
                                pathwayId: "" + pathwayId,
                                stageId: "" + stageId,
                            })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.patchRule = function (ruleId, ruleData) { return __awaiter(_this, void 0, void 0, function () {
            var patchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        patchData = __assign(__assign(__assign(__assign({}, ruleData), { who_detail: JSON.stringify(ruleData.whoDetail), when_detail: JSON.stringify(ruleData.whenDetail), what_detail: JSON.stringify(ruleData.whatDetail) }), (ruleData.metadata ? { metadata: JSON.stringify(ruleData.metadata) } : {})), { audience_type: ruleData.audienceType });
                        return [4 /*yield*/, this.patchRequest('patchRule', patchData, 'Unable to update Rule', {
                                ruleId: "" + ruleId,
                            })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.transitionAppUserToPathwayStage = function (appUserId, appUserPathwayId, newStageSlug) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRequest('transitionAppUserToPathwayStage', { new_stage_slug: newStageSlug }, 'Unable to transition App User to Pathway Stage for Pathways service', undefined, { appUserId: "" + appUserId, appUserPathwayId: "" + appUserPathwayId })];
                    case 1: return [2 /*return*/, (_a.sent()).text()];
                }
            });
        }); };
        this.triggerAdhocRule = function (appUserId, appUserPathwayId, ruleId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRequest('triggerAdhocRule', { rule_id: ruleId }, 'Unable to trigger Adhoc Rule for Pathways service', undefined, { appUserId: "" + appUserId, appUserPathwayId: "" + appUserPathwayId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.createEngagementCheck = function (pathwayId, checkData) { return __awaiter(_this, void 0, void 0, function () {
            var engagement_events, what, postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        engagement_events = checkData.engagement_events
                            ? JSON.stringify(checkData.engagement_events)
                            : undefined;
                        what = checkData.what ? JSON.stringify(checkData.what) : undefined;
                        postData = __assign(__assign({}, checkData), { engagement_events: engagement_events, what: what });
                        postData = JSON.parse(JSON.stringify(postData));
                        return [4 /*yield*/, this.postRequest('createEngagementCheck', postData, 'Unable to create new Engagement Check', undefined, { pathwayId: "" + pathwayId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.patchEngagementCheck = function (pathwayId, checkData) { return __awaiter(_this, void 0, void 0, function () {
            var engagement_events, what, postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        engagement_events = checkData.engagement_events
                            ? JSON.stringify(checkData.engagement_events)
                            : undefined;
                        what = checkData.what ? JSON.stringify(checkData.what) : undefined;
                        postData = __assign(__assign({}, checkData), { engagement_events: engagement_events, what: what });
                        postData = JSON.parse(JSON.stringify(postData));
                        return [4 /*yield*/, this.patchRequest('patchEngagementCheck', postData, 'Unable to create new Engagement Check', {
                                pathwayId: "" + pathwayId,
                                checkId: "" + checkData.id,
                            })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.deleteEngagementCheck = function (pathwayId, checkId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteRequest('deleteEngagementCheck', 'Unable to create new Engagement Check', {
                            pathwayId: "" + pathwayId,
                            checkId: "" + checkId,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.listEngagementChecks = function (pathwayId, pageNumber) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequest('listEngagementChecks', 'Unable to list new Engagement Check', { page: pageNumber || 1 }, { pathwayId: "" + pathwayId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.listPathwaySnapshots = function (pathwayId, page) {
            if (page === void 0) { page = 1; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getRequest('listPathwaySnapshots', "Unable to get list of snapshots for Pathway ID " + pathwayId, { page: page }, { pathwayId: "" + pathwayId })];
                        case 1: return [2 /*return*/, (_a.sent()).json()];
                    }
                });
            });
        };
        this.createPathwaySnapshot = function (pathwayId, snapshotData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Object.keys(snapshotData).forEach(function (key) {
                            return snapshotData[key] === undefined &&
                                delete snapshotData[key];
                        });
                        return [4 /*yield*/, this.postRequest('createPathwaySnapshot', snapshotData, "Unable to create snapshot for Pathway ID " + pathwayId, undefined, { pathwayId: "" + pathwayId })];
                    case 1: 
                    // const postData = {
                    //   name: snapshotData.name,
                    //   description: snapshotData.description,
                    // };
                    return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.sharePathwaySnapshot = function (pathwayId, snapshotId, sharedWith) { return __awaiter(_this, void 0, void 0, function () {
            var postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = sharedWith
                            ? { shared_with: sharedWith.join(',') }
                            : {};
                        return [4 /*yield*/, this.postRequest('sharePathwaySnapshot', postData, "Unable to share snapshot ID " + snapshotId + " for Pathway ID " + pathwayId, undefined, { pathwayId: "" + pathwayId, snapshotId: "" + snapshotId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.unsharePathwaySnapshot = function (pathwayId, snapshotId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRequest('unsharePathwaySnapshot', {}, "Unable to unshare snapshot ID " + snapshotId + " for Pathway ID " + pathwayId, undefined, { pathwayId: "" + pathwayId, snapshotId: "" + snapshotId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.listSharedPathwaySnapshots = function (page) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequest('listSharedPathwaySnapshots', 'Unable to list shared snapshots', this.buildQueryStringParameters({ page: page }))];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.useSharedPathwaySnapshot = function (snapshotId, indexEventTypes, existingPathwayId) { return __awaiter(_this, void 0, void 0, function () {
            var postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = { index_event_types: JSON.stringify(indexEventTypes) };
                        if (existingPathwayId) {
                            postData['existing_pathway'] = existingPathwayId;
                        }
                        return [4 /*yield*/, this.postRequest('useSharedPathwaySnapshot', postData, "Unable to use shared snapshot ID " + snapshotId, undefined, { snapshotId: "" + snapshotId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.actionJourneyEntry = function (appUserId, journeyId, entryId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRequest('actionJourneyEntry', {}, "Unable to action journey entry " + journeyId, undefined, { appUserId: "" + appUserId, journeyId: "" + journeyId, entryId: "" + entryId })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        if (!appToken) {
            throw PathwaysError('You must specify appToken');
        }
        if (!jwt) {
            throw PathwaysError('You must specify a JWT');
        }
        if (!options) {
            this.options = defaultOptions;
        }
        else {
            this.options = __assign(__assign({}, defaultOptions), options);
            if (!this.options.baseUrl) {
                this.options.baseUrl = defaultOptions.baseUrl;
            }
        }
        this.fetch = this.options.fetch || window.fetch.bind(window);
        this.options.baseUrl = (_a = this.options.baseUrl) === null || _a === void 0 ? void 0 : _a.replace('{{app_ubiquity_token}}', this.appToken);
    }
    PathwaysAdminClient.prototype.buildPath = function (pathTemplate, pathParameters) {
        if (!pathParameters)
            return pathTemplate;
        var re = /{{([A-Za-z]+)}}/;
        var path = pathTemplate;
        var match;
        while ((match = re.exec(path)) !== null) {
            path = path.replace(match[0], pathParameters[match[1]]);
        }
        return path[path.length - 1] === '/' ? path : path + "/";
    };
    PathwaysAdminClient.prototype.getUrl = function (endpoint, queryStringParameters, pathParameters) {
        var result;
        result = "" + this.options.baseUrl + this.buildPath(pathMap[endpoint], pathParameters) + (queryStringParameters
            ? Object.keys(queryStringParameters).reduce(function (acc, key) { return "" + acc + key + "=" + queryStringParameters[key] + "&"; }, '?')
            : '');
        return result;
    };
    return PathwaysAdminClient;
}());
export default PathwaysAdminClient;
//# sourceMappingURL=client.js.map